import { Button, Modal, Image, Header } from "semantic-ui-react";
// import { Anchorme } from "react-anchorme";
import AutoLink from "./AutoLink";
import Countdown, { zeroPad } from "react-countdown";
import { useState } from "react";

import moment from "moment";
const GroupError = (props) => {
  const [countdown, setCountdown] = useState(Date.now() + 5000);
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <p>Now!</p>;
    } else {
      // Render a countdown
      return <span>in... {zeroPad(seconds)}</span>;
    }
  };
  const {
    amcError,
    regalError,
    cinemarkError,
    marqueeError,
    handleDismissError,
    campaign,
    groupSizeError,
    date,
    zipCode,
    handleGetLatLong,
    defaultAmcLink,
    defaultRegalLink,
    defaultCinemarkLink,
    defaultMarqueeLink,
  } = props;
  const defaultAtomTickets = `For parties of 30 or less, you can purchase your Group Tickets directly through Atom Tickets.`;
  const defaultGroupSizeError = groupSizeError;
  const defaultAmc = `For AMC theaters with parties of ${
    campaign.amcThreshold || 30
  } or less, please purchase tickets directly from AMC.`;

  const defaultRegal = `For Regal theaters with parties of ${
    campaign.regalThreshold || 30
  } or less, please purchase tickets directly from Regal.`;
  const defaultCinemark = `For Cinemark theaters with parties of ${
    campaign.cinemarkThreshold || 30
  } or less, please purchase tickets directly from Cinemark.`;
  const defaultMarquee = `For Marquee Cinemas with parties of ${
    campaign.marqueeThreshold || 50
  } or less, please visit Marquee Cinemas’ website, app, or box office to purchase tickets.`;

  const handleRedirect = (link) => {
    window.top.location.href = link;
  };

  const amcLink = campaign.amcRedirectUrl || defaultAmcLink;
  const regalLink = campaign.regalRedirectUrl || defaultRegalLink;
  const cinemarkLink = campaign.cinemarkRedirectUrl || defaultCinemarkLink;
  const marqueeLink = campaign.marqueeRedirectUrl || defaultMarqueeLink;

  return (
    <Modal open size="tiny">
      {campaign.enableAtomTickets && campaign.atomTicketsUrl && (
        <Modal.Content
          style={{ backgroundColor: "#000000", border: "1px solid #62C9FC" }}
        >
          <div>
            <div style={{ padding: 20 }}>
              <Image src="/images/atom-tickets.png" width="500px" />
            </div>
            <Header inverted content={<AutoLink text={defaultAtomTickets} />} />
            <div style={{ marginTop: "10px", color: "#FFFFFF" }}>
              Redirecting you{" "}
              <Countdown
                date={countdown}
                renderer={renderer}
                onComplete={() =>
                  handleRedirect(
                    `${campaign.atomTicketsUrl}?${handleGetLatLong(
                      zipCode
                    )}date=${moment(date).format("YYYY-MM-DD")}&ref=pap`
                  )
                }
              />
            </div>
          </div>
        </Modal.Content>
      )}
      {(!campaign.enableAtomTickets || !campaign.atomTicketsUrl) && (
        <Modal.Content>
          {groupSizeError && (
            <div>
              {/* <div style={{ padding: 20 }}>
            <Image src="/images/marquee-cinemas.jpg" width="500px" />
          </div> */}
              <Header content={<AutoLink text={defaultGroupSizeError} />} />
            </div>
          )}
          {marqueeError && (
            <div>
              <div style={{ padding: 20 }}>
                <Image src="/images/marquee-cinemas.jpg" width="500px" />
              </div>
              <Header
                content={
                  <AutoLink text={campaign.marqueeText || defaultMarquee} />
                }
              />
              <div style={{ marginTop: "10px" }}>
                Redirecting you in...{" "}
                <Countdown
                  date={countdown}
                  renderer={renderer}
                  onComplete={() => handleRedirect(marqueeLink)}
                />
              </div>
            </div>
          )}
          {amcError && (
            <div>
              <div style={{ padding: 20 }}>
                <Image src="/images/amc-logo.png" width="500px" />
              </div>
              <Header
                content={<AutoLink text={campaign.amcText || defaultAmc} />}
              />
              <div style={{ marginTop: "10px" }}>
                Redirecting you in...{" "}
                <Countdown
                  date={countdown}
                  renderer={renderer}
                  onComplete={() => handleRedirect(amcLink)}
                />
              </div>
            </div>
          )}
          {regalError && (
            <div>
              <div style={{ padding: 20 }}>
                <Image src="/images/regal-logo.png" width="500px" />
              </div>
              <Header
                content={<AutoLink text={campaign.regalText || defaultRegal} />}
              />
              <div style={{ marginTop: "10px" }}>
                Redirecting you in...{" "}
                <Countdown
                  date={countdown}
                  renderer={renderer}
                  onComplete={() => handleRedirect(regalLink)}
                />
              </div>
            </div>
          )}
          {cinemarkError && (
            <div>
              <div style={{ padding: 20 }}>
                <Image src="/images/cinemark-logo.png" width="500px" />
              </div>
              <Header
                content={
                  <AutoLink text={campaign.cinemarkText || defaultCinemark} />
                }
              />
              <div style={{ marginTop: "10px" }}>
                Redirecting you in...{" "}
                <Countdown
                  date={countdown}
                  renderer={renderer}
                  onComplete={() => handleRedirect(cinemarkLink)}
                />
              </div>
            </div>
          )}
        </Modal.Content>
      )}

      {/* <Modal.Actions>
        <Button content="Dismiss" onClick={handleDismissError} />
      </Modal.Actions> */}
    </Modal>
  );
};
export default GroupError;
